import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Status = () => {
    document.title = "Sənədlərdə keçirilib";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Sənədlərdə keçirilib", value: "/common/status", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sənədlərdə keçirilib</h2>
                    <p>
                        Bütün sənədlərdə keçirilib <b>aktiv</b> olmalıdır. <b>Deaktiv</b> olduqda sənəd <mark>bazaya oturmur</mark>, və qaralama kimi istifadə
                        olunur.
                    </p>
                    <img src="/images/common/status.gif" alt="Sənədlərdə keçirilib" />
                </article>
            </div>
        </div>
    );
};
